// Opens the IC creator modal. Shared entry point: the lab's canvas toolbar reaches it
// through window.labLayout('openIcCreator') (the navbar "IC" button it replaces had
// this logic inline).
export const handleOpenIcCreator = ({ subscription_name, setIcCreatorOpen }) => {
  if (typeof gtag === "function") {
    gtag("event", "integrated_circuit_builder", { "event_category": "Lab", "event_label": "In Lab" });
  }

  if (subscription_name == 'starter') {
    window.thumbs.alert("Integrated circuit modeling is not available in starter version");
    return;
  }

  setIcCreatorOpen(true);
};
